/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const TowelRack = createLucideIcon("towel-rack", [
  ["path", { d: "M22 7h-2", key: "1okbx2" }],
  [
    "path",
    {
      d: "M6.5 3h11A2.5 2.5 0 0 1 20 5.5V20a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V5.5a1 1 0 0 0-5 0V17a1 1 0 0 0 1 1h4",
      key: "kc32tg"
    }
  ],
  ["path", { d: "M9 7H2", key: "ahf7b7" }]
]);

export { TowelRack as default };
//# sourceMappingURL=towel-rack.js.map
